export const DEFAULT_EMPTY_VALUE = 'No disponible';
export const DEFAULT_WRONG_DATE = 'Fecha inválida';
